import { useState } from 'react';
import Application from '../Application';
const ExternalApplication = props => {
    const [template, ] = useState(window.PRELOADED_STATE?.externalApplication?.template ?? null);
    return (
        <div>
            <Application
                externalMode={true}
                template={template}
                isTimedout={props.isTimedout}
            />
        </div>
    );
};
export default ExternalApplication;
